import { defineMessages, MessageDescriptor } from 'react-intl';

export type TargetMessages = {
  course: MessageDescriptor;
};

export const ar: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_ar',
  },
});

export const da: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_da',
  },
});

export const de: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_de',
  },
});

export const el: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_el',
  },
});

export const en: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_en',
  },
});

export const en_us: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_en_us',
  },
});

export const es: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_es',
  },
});

export const es_mx: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_es_mx',
  },
});

export const fa: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_fa',
  },
});

export const he: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_he',
  },
});

export const hi: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_hi',
  },
});

export const fr: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_fr',
  },
});

export const id: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_id',
  },
});

export const is: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_is',
  },
});

export const it: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_it',
  },
});

export const jp_full: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_jp_full',
  },
});

export const jp_romaji: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_jp_romaji',
  },
});

export const ko: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_ko',
  },
});

export const mn: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_mn',
  },
});

export const nl: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_nl',
  },
});

export const no: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_no',
  },
});

export const pl: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_pl',
  },
});

export const pt: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_pt',
  },
});

export const pt_br = defineMessages({
  course: {
    id: 'seo_navigation_course_pt_br',
  },
});

export const ru: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_ru',
  },
});

export const sl: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_sl',
  },
});

export const sv: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_sv',
  },
});

export const sw: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_sw',
  },
});

export const th: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_th',
  },
});

export const tr: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_tr',
  },
});

export const uk: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_uk',
  },
});

export const yo: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_yo',
  },
});

export const zh_cn: TargetMessages = defineMessages({
  course: {
    id: 'seo_navigation_course_zh_cn',
  },
});
